class CustomProductForm extends HTMLElement {
  constructor() {
    super();

    // Pre-bind methods here
    this.onSubmit = this.onSubmit.bind(this);
  }

  // Connected callback
  connectedCallback() {
    console.log('connected..');
    this.form = this.querySelector('form[action="/cart/add"]');
    this.button = this.form?.querySelector('button[type="submit"]');

    if (!this.form) return;

    // Attach event listener inside connectedCallback
    this.form.addEventListener('submit', this.onSubmit);
  }

  // Handle form submission
  async onSubmit(e) {
    e.preventDefault();

    this.classList.add('cus_loading');
    const formData = new FormData(this.form);

    try {
      // const crlear = await fetch('/cart/clear.js');
      const response = await fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        body: formData
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      window.location.href = '/cart';
    } catch (error) {
      console.error(error);
    } finally {
      this.classList.remove('cus_loading');
    }
  }
}
customElements.define('custom-product-from', CustomProductForm);
